module.exports = __webpack_public_path__ + "Lato-LightItalic.daea7167a5ff7aed0968.eot";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-LightItalic.eot
// module id = ../../../../../src/assets/fonts/Lato-LightItalic.eot
// module chunks = styles